import { render, staticRenderFns } from "./vendi.vue?vue&type=template&id=c92b5e34&scoped=true&"
import script from "./vendi.vue?vue&type=script&lang=ts&"
export * from "./vendi.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c92b5e34",
  null
  
)

export default component.exports